import type { PaletteOptions } from "@mui/material"

const Palette: PaletteOptions = {
  primary: {
    main: '#01689B',
    light: '#CCE0F1'
  }
}

export default Palette